import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { SITE } from "@/lib/i18n";
import { MessageCircle } from "lucide-react";

export const WhatsAppButton = () => {
  const { lang, t } = useLang();
  const text = encodeURIComponent(
    lang === "es" ? SITE.whatsapp_text_es : SITE.whatsapp_text_en
  );
  const href = `https://wa.me/${SITE.whatsapp_number}?text=${text}`;

  return (
    <a
      data-testid="whatsapp-btn"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label={t.misc.whatsapp}
      className="fixed bottom-6 right-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/30 blur-xl scale-110 animate-pulse pointer-events-none" />
      <span className="relative flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe57] text-white pl-4 pr-5 py-3.5 rounded-full shadow-xl shadow-black/20 transition-all">
        <MessageCircle size={20} strokeWidth={2} />
        <span className="hidden sm:inline text-sm font-medium">WhatsApp</span>
      </span>
    </a>
  );
};
